<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { get_local_ip, real_id } from '../../../../../helpers/interface_helpers';
	//Services
	import { localReq, postReq } from '../../../../../services/http';
	import { format } from '../../../../../services/i18n';
	//Stores
		//Design system components
	import { Button, Radio, toast } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	let types = ['open', 'close', 'stop'];
	const options = [
		$format('power_on_default_open', {
			default: 'Open: this {device.category} device will open, when it has power.',
		}),
		$format('power_on_default_close', {
			default: 'Close: this {device.category} device will close, when it has power.',
		}),
		$format('power_on_default_stop', {
			default: 'Stop: this {device.category} device will do nothing, when it has power.',
		}),
	];

	const defaultOptionsNewLayout = [
		{
			title: $format('power_on_default_open_new_layout_title', {
				default: 'Open',
			}),
			description: $format('power_on_default_open_new_layout_description', {
				default: 'Opens the cover when power is restored.',
			}),
		},
		{
			title: $format('power_on_default_close_new_layout_title', {
				default: 'Close',
			}),
			description: $format('power_on_default_close_new_layout_description', {
				default: 'Closes the cover when power is restored.',
			}),
		},
		{
			title: $format('power_on_default_stop_new_layout_title', {
				default: 'Stop',
			}),
			description: $format('power_on_default_stop_new_layout_description', {
				default: 'The cover will do nothing when power is restored.',
			}),
		},
	];
	let settings = $settingsStore;

	let selected = settings['rollers'][device.channel].default_state;

	let cache = selected;

	let loading = false;

	let localIp = get_local_ip(device.id);

	const setDefault = (state) => {
		selected = state;
	};

	const sentRequest = async () => {
		if (cache !== selected) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings/roller/${device.channel}`, 'post', {
					default_state: selected,
				});
			} else {
				res = await postReq(`device/relay/roller/settings/default_state`, {
					roller_id: device.channel,
					state: selected,
					id: device.id,
				});
			}

			if (res.isok) {
				settings['rollers'][device.channel].default_state = selected;
				toast.open({
					type: 'success',
					title:
						$format('power_on_default_scc_toast') || `Power on was changed to ${selected}.`,
				});
				devices_settings.update_devices_settings(device.id, settings);
				cache = selected;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				selected = cache;
			}
			loading = false;
		}
	};
</script>

{#if $showNewLayout}
	{#each types as _type, i}
		<Radio
			class="mb-s"
			size="m"
			{selected}
			value={_type}
			on:click={() => setDefault(_type)}
			id={`power-on-${_type}`}
			info={defaultOptionsNewLayout[i].description}
		>
			{defaultOptionsNewLayout[i].title}
		</Radio>
	{/each}
{:else}
	{#each types as _type, i}
		<Radio size="m" {selected} value={_type} on:click={() => setDefault(_type)} id="radio-7witvpk"
			>{options[i]}</Radio
		>
	{/each}
{/if}

<Button class={$showNewLayout ? 'mt-m' : 'mt-s'} {loading} size="m" width="full" on:click={sentRequest}
	>{$format('button_save')}</Button
>
